import { render, staticRenderFns } from "./ProdutoCategorizado.vue?vue&type=template&id=3a612200&scoped=true&"
import script from "./ProdutoCategorizado.vue?vue&type=script&lang=js&"
export * from "./ProdutoCategorizado.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoCategorizado.vue?vue&type=style&index=0&id=3a612200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a612200",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VIcon,VSpacer})
